import { showError } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { updatePaymentInfo } from './update_payment_info'
import { updateStripeCard } from './update_stripe_card'

export const upgradeSubscription = createAsyncThunk(
  'subscription/upgrade',
  async (params, { rejectWithValue, dispatch }) => {
    const { tier, frequency, billingAction, stripe, elements, billingAddress, taxId, isStripeProvider, billingCountry, billingZip } = params

    if (stripe) {
      if (!isStripeProvider) {
        const { success, errorMessage } = await dispatch(updateStripeCard({ stripe, elements, billingAddress, taxId }))
        if (!success) {
          return rejectWithValue({
            error: errorMessage,
            isCardError: true
          })
        }
      } else {
        const result = await dispatch(updatePaymentInfo({ stripe, elements, billingCountry, billingZip }))
        if (result.error) {
          return rejectWithValue({
            error: I18n.t('errors.billing.server'),
            isCardError: true
          })
        }
      }
    }

    const requestParams = billingAction === 'upgrade_tier'
      ? {
        url: '/api/billing/subscription/tier',
        method: 'PUT',
        data: {
          tier
        }
      }
      : {
        url: '/api/billing/subscription/frequency',
        method: 'PUT',
        data: {
          frequency
        }
      }

    const [upgradeSuccess, response] = await httpRequest(requestParams)

    if (!upgradeSuccess) {
      const { payload: { api_error_code: errorCode } } = response

      if (errorCode === 'payment_processing_failed') {
        return rejectWithValue({
          error: response.message,
          isCardError: true
        })
      }

      dispatch(showError(response.message))
    }

    return true
  }
)
